export function msSincePageLoadStarted(): number {
    return performance.now();
}
